import { scrollDetect } from '../includes/scroll-detect.js';
import { mainPads } from '../includes/main-top-padding.js';
import { multiMap } from '../map/map-multi.js';


export default {
  init() {
    // add body class on scroll up/down
    scrollDetect();
    // use google map anywhere on the site
    multiMap();

    let img = $('#hero-slider-image').attr('src');
    if (img) {
      $('#hero').css('background-image', 'url("'+img+'")');
    }

    // add caret down on all header nav with child UL <li><a>link</a> <ul subnav> </li>....
    $('#main-nav-bar li:has(> ul)').addClass('sfl-has-children');

    // used fake button to satisfy layout... this will click the real button on click
    $('#footer-submit').click( function() {
        $('#footer-form .gform_footer .gform_button').click();
    });

    // get the current active service category
    var currentCat = $('#service_features .btn-group .btn.active').data('category_slug');
    // filter service_list based on current category
    $('#service_list li[data-category_slug="'+currentCat+'"]').addClass('active');
    // detect category button click and filter service_list
    $('#service_features .btn-group .btn').on('click', function() {
        var category = $(this).data('category_slug')
        $('#service_features .btn-group .btn').removeClass('active');
        $(this).addClass('active');

        $('#service_list li').removeClass('active');
        $('#service_list li[data-category_slug="'+category+'"]').addClass('active');
    });

    //banner carousel
    $('#banners_carousel .banners_carousel_wrap').bxSlider({
      slideWidth: 200,
      adaptiveHeight: false,
      minSlides: 1,
      maxSlides: 5,
      moveSlides: 1,
      shrinkItems: true,
      slideMargin: 30,
      infiniteLoop: false,
      pager: false,
      auto: false,
      useCSS: false,
      hideControlOnEnd: true,
    });

    // video gallery
    if ( $('#video_list').length ) {
      // load first video onLoad
      $('#video_player iframe').attr('src', 'https://www.youtube.com/embed/' + $('#video_list ul li:first a').data('id') +'?fs=1&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0&modestbranding=1')

      // change video on click
      $('#video_list a').click( function() {
          $('#video_list li').removeClass('active')
          $(this).parent('li').addClass('active')
          $('#video_player iframe').attr('src', 'https://www.youtube.com/embed/' + $(this).data('id') +'?autoplay=1&fs=1&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0&modestbranding=1')
          return false
      });
    }


    // gallery lightbox
    $('.modalLightbox').click( function() {
        $('#modalLightboxImg').attr('src', $(this).attr('href') )
        $('#modalLightbox').modal({
          show: true,
        });
        return false;
    });

    $('#main-nav-bar > li:last-child > a, #footer_logo .btn, a[href="#quoteForm"]').click( function() {
        $('#quoteForm').modal({
          show: true,
        });

        return false;
    });

    if ((window.location.href.indexOf('?cid=') > 0) ||
      (window.location.href.indexOf('?utm_medium=') > 0) ||
      (window.location.href.indexOf('?utm_source=') > 0) ||
      (window.location.href.indexOf('?utm_campaign=') > 0) ||
      (window.location.href.indexOf('?gclid=') > 0)) {
        (function() {
          var domainsToDecorate = [
              'bonedry.com/', //add or remove domains (without https or trailing slash)
        ],

        queryParams = [
          'cid',
          'utm_medium', //add or remove query parameters you want to transfer
          'utm_source',
          'utm_campaign',
          'gclid',
        ]

        // do not edit anything below this line
        var links = document.querySelectorAll('a');

        // check if links contain domain from the domainsToDecorate array and then decorates
        for (var linkIndex = 0; linkIndex < links.length; linkIndex++) {
          for (var domainIndex = 0; domainIndex < domainsToDecorate.length; domainIndex++) {
            if (links[linkIndex].href.indexOf(domainsToDecorate[domainIndex]) > -1 && links[linkIndex].href.indexOf('#') === -1) {
              links[linkIndex].href = decorateUrl(links[linkIndex].href);
            }
          }
        }
        // decorates the URL with query params
        function decorateUrl(urlToDecorate) {
            urlToDecorate = (urlToDecorate.indexOf('?') === -1) ? urlToDecorate + '?' : urlToDecorate + '&';
            var collectedQueryParams = [];
            for (var queryIndex = 0; queryIndex < queryParams.length; queryIndex++) {
                if (getQueryParam(queryParams[queryIndex])) {
                    collectedQueryParams.push(queryParams[queryIndex] + '=' + getQueryParam(queryParams[queryIndex]))
                }
            }
            return urlToDecorate + collectedQueryParams.join('&');
        }

        // borrowed from https://stackoverflow.com/questions/831030/
        // a function that retrieves the value of a query parameter
        function getQueryParam(name) {
          if (name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(window.location.search)) // eslint-disable-line no-cond-assign
            return decodeURIComponent(name[1]);
        }
        })();
    }

    $('.slide-partners').bxSlider({
      // minSlides: 1,
      // maxSlides: 10,
      slideWidth: 189,
      slideMargin: 0,
      infiniteLoop: true,
      autoHover: true,
      autoControls: true,
      controls: true,
    });

    $('.partner-box').click(function(){
      $('.partner-box').removeClass('active');
      $(this).addClass('active');
      var x = $(this).attr('data-partner');
      $('.image-content-row').removeClass('is-active');
      $('div[data-partner='+ x +']').addClass('is-active');
    });

    $('.slider-gallery').bxSlider({
      fade: false,
      pagerCustom: '.slider-nav-thumbnails',
    });

    $('.slider-nav-thumbnails').bxSlider({
      pager: false,
      maxSlides: 12,
      minSlides: 2,
      slideWidth: 100,
      slideMargin: 20,
    });

    $('.before-after-items').bxSlider({
      fade: false,
      pagerCustom: '.slider-nav-thumbnails',
      touchEnabled: false,
    });

    // Remove active class from all thumbnail slides
    $('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');

    // Set active class to first thumbnail slides
    $('.slider-nav-thumbnails .slick-slide').eq(0).addClass('slick-active');

     // On before slide change match active thumbnail to current slide
    $('.slider-gallery').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      var mySlideNumber = nextSlide;
      $('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');
      $('.slider-nav-thumbnails .slick-slide').eq(mySlideNumber).addClass('slick-active');
    });

    $('.ba-slider').each(function(){
      var cur = $(this);
      var width = cur.width()+'px';
      cur.find('.resize img').css('width', width);
      drags(cur.find('.handle'), cur.find('.resize'), cur);
    });

    function drags(dragElement, resizeElement, container) {
      dragElement.on('mousedown touchstart', function(e) {

          dragElement.addClass('draggable-item');
          resizeElement.addClass('resizable-item');

          var startX = (e.pageX) ? e.pageX : e.originalEvent.touches[0].pageX;

          var dragWidth = dragElement.outerWidth(),
              posX = dragElement.offset().left + dragWidth - startX,
              containerOffset = container.offset().left,
              containerWidth = container.outerWidth();

          var minLeft = containerOffset + 10;
          var maxLeft = containerOffset + containerWidth - dragWidth - 10;

          dragElement.parents().on('mousemove touchmove', function(e) {

              var moveX = (e.pageX) ? e.pageX : e.originalEvent.touches[0].pageX;

              var leftValue = moveX + posX - dragWidth;

              if (leftValue < minLeft) {
                  leftValue = minLeft;
              } else if (leftValue > maxLeft) {
                  leftValue = maxLeft;
              }

              var widthValue = (leftValue + dragWidth / 2 - containerOffset) * 100 / containerWidth + '%';

              jQuery('.draggable-item').css('left', widthValue).on('mouseup touchend touchcancel', function() {
                  jQuery(this).removeClass('draggable-item');
                  resizeElement.removeClass('resizable-item');
              });

              jQuery('.resizable-item').css('width', widthValue);
          }).on('mouseup touchend touchcancel', function() {
              dragElement.removeClass('draggable-item');
              resizeElement.removeClass('resizable-item');
          });
          e.preventDefault();
      }).on('mouseup touchend touchcancel', function(e) {
          e.preventDefault();
          dragElement.removeClass('draggable-item');
          resizeElement.removeClass('resizable-item');
      });
    }

    function homeHeroSpacing() {
      let windowHeight = $(window).height()
      let windowWidth = $(window).width()

      let marginTop = (windowWidth > 992) ? $('#header').height() : 100
      let navBarHeight = (windowWidth > 992) ? $('#header').height() : 100
      let sliderHeight = windowHeight - navBarHeight

      $('#homeCarousel, #homeCarousel .carousel-inner').css({
          'height': windowHeight + 'px',
      })

      $('#homeCarousel .carouselContainer').css({
          'marginTop': marginTop + 'px',
          'height' : sliderHeight + 'px',
      })

      $('.carousel-item img').css('height', windowHeight + 'px' )
    }

    homeHeroSpacing();

    $(window).on('resize', function(){
      window.setTimeout( homeHeroSpacing, 1000 ); // delay to recompute correct width/height
    })

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // add top padding on <main> *** fix for fixed top nav
    mainPads();
    $( window ).resize(function() {
      mainPads();
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js